module.exports = __webpack_public_path__ + "img/chevron-solid-white.cebfeb00.svg";